import type { AgentIconType } from './agentIconType';

export type AgentBrand = {
	readonly name: string;
	readonly agentIcon: AgentIconType;
};

const AGENT_BRANDS: readonly AgentBrand[] = [
	{ name: 'Claude Code', agentIcon: 'claude' },
	{ name: 'Claude', agentIcon: 'claude' },
	{ name: 'Codex', agentIcon: 'codex' },
	{ name: 'Rovo', agentIcon: 'rovo' },
	{ name: 'Cursor', agentIcon: 'cursor' },
	{ name: 'ChatGPT', agentIcon: 'chatgpt' },
	{ name: 'Dia', agentIcon: 'dia' },
];

const PRESENCE_AGENT_BRANDS: readonly AgentBrand[] = [
	{ name: '1P', agentIcon: 'first-party' },
	{ name: '1P Agent', agentIcon: 'first-party' },
	{ name: 'Amplitude', agentIcon: 'amplitude' },
	{ name: 'Antigravity', agentIcon: 'antigravity' },
	{ name: 'Canva', agentIcon: 'canva' },
	{ name: 'Cortex', agentIcon: 'cortex' },
	{ name: 'Databricks', agentIcon: 'databricks' },
	{ name: 'Figma', agentIcon: 'figma' },
	{ name: 'Gemini', agentIcon: 'gemini' },
	{ name: 'GitHub Copilot', agentIcon: 'github-copilot' },
	{ name: 'Grok', agentIcon: 'grok' },
	{ name: 'Hermes Agent', agentIcon: 'hermes' },
	{ name: 'Kiro', agentIcon: 'kiro' },
	{ name: 'Lovable', agentIcon: 'lovable' },
	{ name: 'Manus', agentIcon: 'manus' },
	{ name: 'Microsoft Copilot', agentIcon: 'microsoft-copilot' },
	{ name: 'OpenAI', agentIcon: 'openai' },
	{ name: 'Replit', agentIcon: 'replit' },
	{ name: 'Slack', agentIcon: 'slack' },
	{ name: 'Visual Studio Code', agentIcon: 'vscode' },
	{ name: 'VS Code', agentIcon: 'vscode' },
	// Deprecated but kept for legacy purposes — some backends still emit these older
	// "<Brand> Agent" account names for Figma, Lovable, and Replit.
	{ name: 'Figma Agent', agentIcon: 'figma' },
	{ name: 'Lovable Agent', agentIcon: 'lovable' },
	{ name: 'Replit Agent', agentIcon: 'replit' },
];

export type GetAgentBrandOptions = {
	/**
	 * Opts into the presence tier. Consumers own the rollout decision because this package
	 * cannot read product feature flags. Defaults to `false` so callers that do not opt in
	 * keep the smaller, always-on brand set.
	 */
	includePresenceBrands?: boolean;
};

/**
 * @private
 * @deprecated Temporary. Resolve agent branding from a supported shared package instead.
 *
 * The " (" separator recognizes per-integration names without matching unrelated
 * accounts. New matches are gated here because callers also use them to replace
 * account names, group activity, and decide whether profile links are available.
 */
export const getAgentBrand = (
	displayName: string,
	{ includePresenceBrands = false }: GetAgentBrandOptions = {},
): AgentBrand | undefined => {
	const matches = ({ name }: AgentBrand) =>
		displayName === name || displayName.startsWith(`${name} (`);

	const brand = AGENT_BRANDS.find(matches);
	if (brand) {
		return brand;
	}

	const presenceBrand = PRESENCE_AGENT_BRANDS.find(matches);
	if (presenceBrand && includePresenceBrands) {
		return presenceBrand;
	}

	return undefined;
};
